import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';
import { useState } from 'react';

import RichText from '../../../Core/RichText';
import OutsideClickHandler from '../../../../utils/outsideClickHandler';
import Container from '../../../Core/Container';

import CardDetails from './CardDetails';
import {
  AccordionButton,
  Heading,
  HeaderSection,
  Grid,
  CardContainer,
  StyledCtas,
  Dropdown,
  DropdownBtn,
  DropdownMenu,
  MobileViewGrid,
  ListBtn,
  AccordianContainer,
} from './styles';

const CardComparisonContainer = ({ data }) => {
  if (!data) return null;

  const { cards, elements, sectionContainerHeading, sectionSubheading, ctas } =
    data;

  const cardItems = cards || elements;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Heading>{children}</Heading>,
      [BLOCKS.HEADING_2]: (_, children) => <Heading>{children}</Heading>,
    },
  };

  const [isGridOpen, setIsGridOpen] = useState(false);
  const [isCardOpen, setIsCardOpen] = useState(false);

  const [isActive, setIsActive] = useState(false);

  const [selectedCard, setSelectedCard] = useState(cardItems[0]);

  return (
    <Container>
      <HeaderSection>
        {sectionContainerHeading && (
          <RichText document={sectionContainerHeading} options={header} />
        )}
        {sectionSubheading && <RichText document={sectionSubheading} />}
      </HeaderSection>

      <OutsideClickHandler
        isActive={isActive}
        callback={() => {
          setIsActive(false);
        }}
      >
        <Dropdown isActive={isActive}>
          <DropdownBtn
            onClick={() => {
              setIsActive(!isActive);
            }}
            aria-expanded={isActive}
          >
            <RichText document={selectedCard?.preHeading} />
          </DropdownBtn>
          <DropdownMenu $isActive={isActive}>
            {cardItems.map(item => {
              return (
                <ListBtn
                  key={item.id}
                  type="button"
                  className={
                    item.preHeading === selectedCard.preHeading ? 'active' : ''
                  }
                  onClick={() => {
                    setSelectedCard(item);
                    setIsActive(false);
                  }}
                >
                  <RichText document={item.preHeading} />
                </ListBtn>
              );
            })}
          </DropdownMenu>
        </Dropdown>
      </OutsideClickHandler>

      <MobileViewGrid>
        <CardContainer>
          <CardDetails
            key={selectedCard.id}
            data={selectedCard}
            isOpen={isCardOpen}
          />
          <AccordionButton
            type="button"
            $isCardOpen={isCardOpen}
            onClick={() => setIsCardOpen(!isCardOpen)}
          />
        </CardContainer>
      </MobileViewGrid>

      <Grid isGridOpen={isGridOpen}>
        {cardItems.map(block => {
          const { id } = block;
          return (
            <CardContainer key={id}>
              <CardDetails key={id} data={block} isOpen={isCardOpen} />
            </CardContainer>
          );
        })}
      </Grid>
      <AccordianContainer>
        {cardItems.map(block => {
          const { id } = block;
          return (
            <AccordionButton
              key={id}
              $isCardOpen={isGridOpen}
              type="button"
              onClick={() => setIsGridOpen(!isGridOpen)}
            />
          );
        })}
      </AccordianContainer>

      {ctas && <StyledCtas ctas={ctas} />}
    </Container>
  );
};

CardComparisonContainer.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default CardComparisonContainer;
